import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Input } from "antd";
import Select from "@components/ResponsiveSelect";

const {Option} = Select;

const isValidPrice = (value) => value !== null && value !== undefined && Number.isFinite(Number(value));

function mapStateToProps(state) {
    return {};
}

class SelectAddNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: ['Baseline Average', 'Post-Period Average', 'Custom'],
            name: props.price ?? null,
        }
    }

    componentDidUpdate(prevProps) {
        // 当 props.price 发生变化时更新 name
        if (!Object.is(prevProps.price, this.props.price)) {
            const nextName = this.props.price ?? null;
            if (!Object.is(this.state.name, nextName)) {
                this.setState({
                    name: nextName,
                });
            }
        }
    }

    onNameChange = event => {
        this.setState({
            name: event.target.value,
        });
        this.props.onSelect('Custom', event.target.value)
    };

    handleChange = (value) => {
        if (value === 'Custom') {
            // 切换到 Custom 时，用当前显示的计算价格作为初始值
            const customPrice = isValidPrice(this.props.calculatedPrice)
                ? this.props.calculatedPrice
                : (this.state.name ?? null);
            this.setState({ name: customPrice });
            this.props.onSelect(value, customPrice);
        } else {
            this.props.onSelect(value, null);
        }
    }

    render() {
        const {items, name} = this.state;
        return (
            <div className="select-add-new-control" style={{ display: 'flex' }}>
                <Select
                    onChange={this.handleChange}
                    placeholder={this.props.placeholder}
                    defaultValue={this.props.default}
                    value={this.props.value}
                    style={{ flex: 1, minWidth: 0 }}
                >
                    {items.map(item => (
                        <Option key={item}>{item}</Option>
                    ))}
                </Select>

                {this.props.value === 'Custom' ? (
                    <Input prefix={'$ '} style={{width:'96px'}} value={name} onChange={this.onNameChange}/>
                ) : (
                    <Input 
                        prefix={'$ '} 
                        style={{width:'96px'}}
                        value={isValidPrice(this.props.calculatedPrice) ? Number(this.props.calculatedPrice).toFixed(3) : ""} 
                        disabled 
                    />
                )}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(SelectAddNew);
